/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react'
import Calendar from 'react-calendar'
import moment from 'moment';

const FilterModal = ({filterModal,setfilterModal,query,setQuery,handleTransactions,dateselected, setdateselected, SetSuccessMessage}) => {
    const [selected, setselected] = useState('date_range');
    const [update, setUpdate] = useState(false);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    const dateRef = useRef();
    
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setdateselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state)
        setdateselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };
    const filter = (e,key,value)=>{
        if(query[key] == undefined){
            query[key] = value
        }else{
            query[key] = query[key].split(',')
            e.target.checked ? query[key].push(value): query[key].splice(query[key].indexOf(value),1)
            query[key] = query[key].join(',')
            if (query[key] === '') delete query[key]
        } 
        setQuery(query)
        setUpdate(true)
    }

    const submitFilter = () => {
        if(dateselected.start_date!=='' && dateselected.end_date!==''){
            query.created_range = `${moment(dateselected.start_date).format('DD/MM/YYYY')},${moment(dateselected.end_date).format('DD/MM/YYYY')}`
            setQuery(query)}
        handleTransactions(query); 
        setfilterModal(false)
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
        
    }

    useEffect(() => {
        setUpdate(false)
    }, [update]);

    const handleClear = () =>{
        if(query.transaction_type) delete query.transaction_type
        if(query.type) delete query.type
        if(query.created_range) delete query.created_range
        setdateselected({
            start_date: '',
            end_date: '',
        });
        setQuery(query)
        handleTransactions(query)
        setfilterModal(false)
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
    }


    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);


    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[575px] mx-auto px-2.5" style={{margin : 'auto'}}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-[530px] h-[430px] pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button type="button"
                            onClick={()=>setfilterModal(false)}
                            className="btn-close1 box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 sm:w-[33%] w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={()=>setselected('date_range')}>
                                    <a href="#pills-pricetab" className={`nav-link block text-base font-semibold text-[#AAA6AF] view-invoice ${selected === 'date_range' ? 'active' : ''} relative w-full`} id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                        aria-controls="pills-price" aria-selected="true">Date  Range
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={()=>setselected('transaction_type')}>
                                    <a href="#pills-profileVertical " className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selected === 'transaction_type' ? 'active' : ''} view-invoice relative w-full`} id="pills-size" data-bs-toggle="pill" data-bs-target="#pills-sizemm" role="tab"
                                        aria-controls="pills-sizemm" aria-selected="false" >Transaction Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={()=>{setselected('type')}}>
                                    <a href="#pills-profileVertical" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selected === 'type' ? 'active' : ''} view-invoice relative w-full`} id="pills-categories" data-bs-toggle="pill" data-bs-target="#pillcategorie" role="tab"
                                        aria-controls="pillcategorie" aria-selected="false">Type
                                    </a>
                                </li>
                            </ul>
                            <div  ref={dateRef} className="tab-content sm:w-[67%] w-[60%] h-[280px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane fade show ${selected === 'date_range' ? 'show active' : ''} px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-3 -mx-1">
                                            <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    onClick={() => handleToggle('start_date')}
                                                    src="images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"/>
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    value={dateselected.start_date === '' ? '' : moment(dateselected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="From Date" />
                                            </div>
                                            {toggle.start_date && (
                                                <Calendar
                                                    value={moment(dateselected.start_date).format('YYYY/MM/DD').start_date}
                                                    onChange={(val) => handleDate(val, 'start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <p className="text-base font-normal text-[#555259] px-2.5 pb-50">to</p>
                                            <div className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <img 
                                                    onClick={() => handleToggle('end_date')}
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"/>
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    value={dateselected.end_date === '' ? '' : moment(dateselected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="To Date" 
                                                />
                                            </div>
                                            {toggle.end_date && (
                                                <Calendar
                                                    value={(dateselected.end_date)}
                                                    onChange={(val) => handleDate(val, 'end_date')}
                                                    minDate={moment(dateselected.start_date).toDate()} 
                                                    placeholder="Date to"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selected === 'transaction_type' ? 'show active' : ''} w-full px-3`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="cursor-pointer">
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center">
                                            <input type="checkbox" id="mn11" onChange={(e)=> filter(e,'transaction_type', 'CASH_DISC')} checked={query.transaction_type && query.transaction_type.includes('CASH_DISC')}/>
                                            <label htmlFor="mn11" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Cash_Disc</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                            <input type="checkbox" id="mn12" onChange={(e)=> filter(e,'transaction_type', 'ADJ_ENTRY')} checked={query.transaction_type && query.transaction_type.includes('ADJ_ENTRY')} />
                                            <label htmlFor="mn12" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Adj_Entry</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                            <input type="checkbox" id="mm13" onChange={(e)=> filter(e,'transaction_type', 'BULK_DISC_FIX')} checked={query.transaction_type && query.transaction_type.includes('BULK_DISC_FIX')} />
                                            <label htmlFor="mm13" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Bulk_Disc_fix</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                            <input type="checkbox" id="mm14" onChange={(e)=> filter(e,'transaction_type', 'BULK_DISC_FULFIL')} checked={query.transaction_type && query.transaction_type.includes('BULK_DISC_FULFIL')} />
                                            <label htmlFor="mm14" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Bulk_Disc_fulfil</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selected === 'type' ? 'show active' : ''} fade px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="cursor-pointer">
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center ">
                                            <input type="checkbox" id="mn15" onChange={(e)=> filter(e,'type', 'Order')} checked={query.type && query.type.includes('Order')} />
                                            <label htmlFor="mn15" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Order</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                            <input type="checkbox"  id="mn16" onChange={(e)=> filter(e,'type', 'Invoice')} checked={query.type && query.type.includes('Invoice')} />
                                            <label htmlFor="mn16" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Invoice</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox31 flex items-center mt-[14px]">
                                            <input type="checkbox" id="mm17" onChange={(e)=> filter(e,'type', 'Adjustment')} checked={query.type && query.type.includes('Adjustment')} />
                                            <label htmlFor="mm17" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">Adjustment</label>
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 pb-5 flex justify-end w-[30%] mr-5">
                                <button type="button" className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" data-bs-dismiss="modal" aria-label="Close" onClick={()=> { handleClear()}}>
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 pb-5 flex justify-end w-[70%]">
                                <button type="button" className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close" onClick={()=> {submitFilter()}}>
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterModal
